/**
 * User preferences API — the caller's own UI preferences (today: the UI locale).
 *
 * Gateway prefix /api/v1/users → user-service. Mirrors
 * services-python/user-service/src/api/routes.py:
 *  - GET   /api/v1/users/me/preferences   → { locale: 'fr' | 'en' | 'ar' | null }
 *  - PATCH /api/v1/users/me/preferences   → body { locale }, returns the saved state
 *
 * Strictly self-scoped (`/users/me/...`): there is no user_id parameter.
 */

import { api } from '@/lib/api/client';

const BASE = '/api/v1/users/me/preferences';

/** Mirrors user-service `UserPreferences`. `locale` is null until the user picks one. */
export interface UserPreferences {
  locale: string | null;
}

/** GET the caller's saved preferences. */
export function getMyPreferences(): Promise<UserPreferences> {
  return api.get<UserPreferences>(BASE);
}

/** PATCH the caller's preferences (partial update). */
export function updateMyPreferences(patch: Partial<UserPreferences>): Promise<UserPreferences> {
  return api.patch<UserPreferences>(BASE, patch);
}
